import { render, staticRenderFns } from "./MarketCategoryPills.vue?vue&type=template&id=167e0cf6&scoped=true&"
import script from "./MarketCategoryPills.vue?vue&type=script&lang=js&"
export * from "./MarketCategoryPills.vue?vue&type=script&lang=js&"
import style0 from "./MarketCategoryPills.vue?vue&type=style&index=0&id=167e0cf6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e0cf6",
  null
  
)

export default component.exports